import { render, staticRenderFns } from "./legado_vetus.vue?vue&type=template&id=718ea640&scoped=true"
import script from "./legado_vetus.vue?vue&type=script&lang=js"
export * from "./legado_vetus.vue?vue&type=script&lang=js"
import style0 from "./legado_vetus.vue?vue&type=style&index=0&id=718ea640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ea640",
  null
  
)

export default component.exports